import * as Sentry from "@sentry/react"
import mixpanel from "mixpanel-browser"
import { startTransition, StrictMode } from "react"
import { hydrateRoot } from "react-dom/client"
import type { ClientOnErrorFunction } from "react-router"
import { HydratedRouter } from "react-router/dom"
import { setMixpanelClient } from "./analytics/useMixpanel.ts"

declare const __MIXPANEL_TOKEN__: string | undefined
declare const __SENTRY_DSN__: string | undefined
declare const __SENTRY_ENV__: string | undefined

if (__MIXPANEL_TOKEN__) {
  mixpanel.init(__MIXPANEL_TOKEN__, {
    api_host: "https://mp.iyk.app",
    persistence: "localStorage",
    autocapture: true,
    track_pageview: true,
    record_sessions_percent: 10
  })
  setMixpanelClient({
    track(event, properties) {
      mixpanel.track(event, properties)
    }
  })
}

if (__SENTRY_DSN__) {
  Sentry.init({
    dsn: __SENTRY_DSN__,
    environment: __SENTRY_ENV__,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false
  })
}

const onError: ClientOnErrorFunction = (error) => {
  Sentry.captureException(error)
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter onError={onError} />
    </StrictMode>
  )
})
